export function nameSplit(name) {
    const Name = name.split(' ');
    const fname = Name[0];
    const lname = Name.slice(1, Name.length).join(' ')
    return [fname,lname]
}